import React, { useState, useEffect, useCallback } from 'react';
import { adminAPI } from '../../lib/api';
import { Button } from '../ui/button';
import { Search, Ban, Shield, ShoppingCart, Package, ChevronLeft, ChevronRight } from 'lucide-react';

const UsersTab = () => {
  const [users, setUsers] = useState([]);
  const [total, setTotal] = useState(0);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const [promoteEmail, setPromoteEmail] = useState('');

  const load = useCallback(() => {
    const params = { page, limit: 20 };
    if (search) params.search = search;
    adminAPI.getUsers(params).then(r => { setUsers(r.data.users); setTotal(r.data.total); }).catch(() => {});
  }, [page, search]);
  useEffect(load, [load]);

  const toggleBlock = async (userId) => { await adminAPI.toggleBlockUser(userId); load(); };
  const promote = async () => {
    if (!promoteEmail) return;
    try { await adminAPI.promoteUser(promoteEmail); setPromoteEmail(''); load(); } catch {}
  };

  return (
    <div data-testid="admin-users">
      <div className="flex flex-wrap gap-2 mb-4">
        <div className="relative flex-1 min-w-[200px]">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#B8D4E3]" />
          <input value={search} onChange={e => { setSearch(e.target.value); setPage(1); }}
            placeholder="Rechercher un utilisateur..." className="w-full h-9 pl-9 pr-3 rounded-lg border border-[#D6E8F0] text-sm" />
        </div>
        <div className="flex gap-1">
          <input value={promoteEmail} onChange={e => setPromoteEmail(e.target.value)}
            placeholder="Email à promouvoir admin" className="h-9 px-3 rounded-lg border border-[#D6E8F0] text-sm w-48" />
          <Button size="sm" onClick={promote} className="bg-[#0C63BF] h-9"><Shield className="w-3.5 h-3.5 mr-1" /> Admin</Button>
        </div>
        <span className="text-xs text-[#5A8BA8] self-center ml-auto">{total} utilisateur{total !== 1 ? 's' : ''}</span>
      </div>
      <div className="space-y-2">
        {users.map(u => (
          <div key={u.id} className="bg-white rounded-xl border border-[#E8F4FD] p-3 sm:p-4 flex items-center gap-3" data-testid={`admin-user-${u.id}`}>
            <div className="w-9 h-9 rounded-lg bg-[#0C63BF] flex items-center justify-center text-white font-bold text-sm shrink-0">{u.first_name?.[0]?.toUpperCase()}</div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center gap-2">
                <p className="text-sm font-semibold text-[#033871] truncate">{u.first_name} {u.last_name}</p>
                {u.is_admin && <span className="px-1.5 py-0.5 bg-[#0C63BF] text-white rounded text-[9px] font-bold">ADMIN</span>}
                {u.is_blocked && <span className="px-1.5 py-0.5 bg-red-500 text-white rounded text-[9px] font-bold">BLOQUE</span>}
              </div>
              <p className="text-xs text-[#5A8BA8] truncate">{u.email}</p>
            </div>
            <div className="flex items-center gap-3 text-xs text-[#5A8BA8] shrink-0">
              <span title="Annonces"><Package className="w-3 h-3 inline" /> {u.listings_count}</span>
              <span title="Achats"><ShoppingCart className="w-3 h-3 inline" /> {u.orders_count}</span>
              {u.avg_rating && <span className="text-amber-500 font-bold">{u.avg_rating.toFixed(1)}★</span>}
            </div>
            {!u.is_admin && (
              <button onClick={() => toggleBlock(u.id)}
                className={`p-2 rounded-lg text-xs transition-colors ${u.is_blocked ? 'bg-green-100 text-green-700 hover:bg-green-200' : 'bg-red-100 text-red-700 hover:bg-red-200'}`}
                title={u.is_blocked ? 'Débloquer' : 'Bloquer'}>
                <Ban className="w-4 h-4" />
              </button>
            )}
          </div>
        ))}
        {users.length === 0 && <p className="text-center text-sm text-[#5A8BA8] py-8">Aucun utilisateur</p>}
      </div>
      {total > 20 && (
        <div className="flex justify-center items-center gap-3 mt-4">
          <button onClick={() => setPage(p => Math.max(1, p - 1))} disabled={page === 1} className="p-1.5 rounded-lg border disabled:opacity-30"><ChevronLeft className="w-4 h-4" /></button>
          <span className="text-sm text-[#5A8BA8]">Page {page}</span>
          <button onClick={() => setPage(p => p + 1)} disabled={users.length < 20} className="p-1.5 rounded-lg border disabled:opacity-30"><ChevronRight className="w-4 h-4" /></button>
        </div>
      )}
    </div>
  );
};

export default UsersTab;
